import React from 'react';
import { URLS } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import SimpleLink from '@wix/da-shared-react/pkg/SimpleLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';

export type Props = {
  className?: string;
};

export const GetPointsLink: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <SimpleLink
      href={URLS.POINTS}
      className={className}
      biData={{
        evid: BiEventType.GET_MORE_POINTS,
      }}
    >
      {t('givePointsPopup.link.getMorePoints')}
    </SimpleLink>
  );
};
GetPointsLink.displayName = 'GetPointsLink';

export default GetPointsLink;
